import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { ContactTemplate } from '../../../types/ContactTemplate';

export const postContactTemplate = async (formData: ContactTemplate) => {
  const response = await CustomAxios.post(`contact_templates`, formData);
  return response.data;
};

type UseCreateContactTemplateProps = {
  onSuccessCallback: (data: ContactTemplate) => void;
};

export function useCreateContactTemplate({ onSuccessCallback }: UseCreateContactTemplateProps) {
  const navigate = useNavigate();

  return useMutation({
    mutationKey: [mutationKeys.createContactTemplate],
    mutationFn: (formData: ContactTemplate) => postContactTemplate(formData),
    onSuccess: (data: ContactTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allContactTemplates, 'new'],
      });
      onSuccessCallback(data);
      navigate(`/${ROUTE_PATHS.CONTACT_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as ContactTemplate;
        queryClient.setQueryData([queryKeys.allContactTemplates, 'new'], template);
      }
    },
  });
}
